import React from 'react';
import './SkeletonLoader.css';

function SkeletonLoader({ variant = 'list', count = 3 }) {
  if (variant === 'dashboard') {
    return (
      <div className="skeleton-dashboard">
        <div className="skeleton-dashboard-hero">
          <div className="skeleton-bone skeleton-dashboard-badge" />
          <div className="skeleton-bone skeleton-dashboard-label" />
          <div className="skeleton-bone skeleton-dashboard-title" />
          <div className="skeleton-bone skeleton-dashboard-btn" />
        </div>
        <div className="skeleton-dashboard-actions">
          <div className="skeleton-bone skeleton-dashboard-action" />
          <div className="skeleton-bone skeleton-dashboard-action" />
        </div>
      </div>
    );
  }

  if (variant === 'volume') {
    return (
      <div className="skeleton-volume">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="skeleton-bone skeleton-volume-bar" />
        ))}
      </div>
    );
  }

  if (variant === 'card') {
    return (
      <div className="skeleton-card-single">
        <div className="skeleton-bone skeleton-card-header" />
        <div className="skeleton-bone skeleton-card-body" />
      </div>
    );
  }

  // Default: list
  return (
    <div className="skeleton-list">
      {[...Array(count)].map((_, i) => (
        <div key={i} className="skeleton-list-card">
          <div className="skeleton-bone skeleton-list-line skeleton-list-line--short" />
          <div className="skeleton-bone skeleton-list-line skeleton-list-line--long" />
          <div className="skeleton-bone skeleton-list-line skeleton-list-line--medium" />
        </div>
      ))}
    </div>
  );
}

export default SkeletonLoader;
